import React, { useState, useEffect, useRef } from 'react'
import { CircleCheck, XCircle, Eye, EyeOff, Lock, ShieldCheck, AlertCircle, Zap, BarChart2, Loader2 } from 'lucide-react'
import { Button } from '../../ui/button'
import { Input } from '../../ui/input'
import { Label } from '../../ui/label'
import { forceResetPassword } from './loginSlice'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorStackData } from '../Common/data/LoginHistoryData/LoginData'
import { useHistory } from "react-router-dom"
import BluestuffLogo from '../Common/BluestuffLogo'
function AddNewPassword() {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();
    const history = useHistory();
    const [showPrev, setShowPrev] = useState(false)
    const [showNew, setShowNew] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    const [errors, setErrors] = useState({
        previousPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    })
    const [formData, setFormData] = useState({
        previousPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    })
    const [errorStack, setErrorStack] = useState({
        len: '',
        num: '',
        caps: '',
        small: '',
        special: '',
    })
    const [isAllClear, setIsAllClear] = useState('')
    const loginToken = localStorage.getItem('totpToken')
    const forceResetPasswordData = useSelector(state => state.loginSlice.forceResetPasswordData);
    const onChangeHandler = (e) => {
        const { name, value } = e.target
        // errorSetter(name, value ? "" : "password cannot be empty");
        if (!(/\s/).test(value)) {

            setFormData((prevState) => {
                return {
                    ...prevState,
                    [name]: value,
                }
            })
            if (name === 'newPassword') matchCheker(name, value)
            validate(name, value);
        }
    }
    const errorSetter = (name, val) => {
        setErrors((prevErrors) => {
            return {
                ...prevErrors,
                [name]: val,
            }
        })
    }
    const handleStackErr = (name, err) => {
        setErrorStack((prevErr) => {
            return {
                ...prevErr,
                [name]: err,
            }
        })
    }

    const matchCheker = (name, value) => {
        let err = ''
        if (value === '' || value === undefined) {
            err = 'Password cannot be empty'
            setErrorStack({
                len: false,
                num: false,
                caps: false,
                small: false,
                special: false,
            })
            errorSetter(name, err)
        }
        if (value.length <= 7) {
            err = 'Password must be atleast 8 characters!'
            handleStackErr('len', false)
            errorSetter(name, err)
        } else {
            handleStackErr('len', true)
        }
        if (value.match(/^(?=.*?[A-Z])/)) {
            handleStackErr('caps', true)
        } else {
            err = 'Password must contain 1 Letter in Capital Case!'
            handleStackErr('caps', false)
            errorSetter(name, err)
        }
        if (value.match(/^(?=.*?[a-z])/)) {
            handleStackErr('small', true)
        } else {
            err = 'Password must contain 1 Letter in Small Case!'
            handleStackErr('small', false)
            errorSetter(name, err)
        }
        if (value.match(/^(?=.*?[0-9])/)) {
            handleStackErr('num', true)
        } else {
            err = 'Password must contain atleast 1 Number!'
            handleStackErr('num', false)
            errorSetter(name, err)
        }
        if (value.match(/^(?=.*?[-_@#$%^&*.])/)) {
            handleStackErr('special', true)
        } else {
            err = 'Password must contain 1 special charecter'
            handleStackErr('special', false)
            errorSetter(name, err)
        }
        return err
    }

    const validate = (name, value) => {
        let err = ''
        if (name === 'previousPassword') {
            if (value) {
                err = "";
            } else {
                err = 'Old password is required'
            }
            errorSetter(name, err);
        }

        if (name === 'newPassword') {
            err = matchCheker(name, value)
            if (value === '') {
                err = 'New password cannot be empty'
            } else {
                if (formData.confirmNewPassword) {
                    if (value !== formData.confirmNewPassword) {
                        errorSetter('confirmNewPassword', 'Password doesnot match')
                    } else {
                        errorSetter('confirmNewPassword', '')
                    }
                }
            }
        }

        if (name === 'confirmNewPassword') {
            if (value === '') {
                err = 'Confirm passaword is required'
                errorSetter(name, err)
            } else {
                err = value !== formData.newPassword ? 'Password doesnot match' : ""
                errorSetter(name, err)
            }
        }
        return err
    }

    const onSubmit = () => {
        const checkPrevPass = validate('previousPassword', formData.previousPassword) === ''
        const checkNewPass = validate('newPassword', formData.newPassword) === ''
        const checkConfirmPass = validate('confirmNewPassword', formData.confirmNewPassword) === ''
        const payload = {
            newPassword: formData.confirmNewPassword,
            oldPassword: formData.previousPassword,
        }
        if (checkPrevPass && checkNewPass && checkConfirmPass) {
            setLoading(true)
            dispatch(forceResetPassword(payload, loginToken));
        }
    }

    useEffect(() => {
        const isAllClear = Object.keys(errorStack).every((item) => errorStack[item])
        setIsAllClear(isAllClear)
        if (isAllClear) {
            // set
            setErrors((prev) => {
                return {
                    ...prev,
                    newPassword: "",
                }
            })
        }
    }, [errorStack]);

    useEffect(() => {
        if (!forceResetPasswordData?.status) {
            setErrors((prev) => {
                return {
                    ...prev,
                    "previousPassword": forceResetPasswordData?.msg
                }
            });
            setLoading(false);
        } else {
            setLoading(false);
            setTimeout(() => history.push("login"), 1000)
        }
    }, [forceResetPasswordData, history]);

    // Keep a ref to the latest onSubmit so the keydown listener never captures stale state
    const onSubmitRef = useRef(onSubmit);
    useEffect(() => { onSubmitRef.current = onSubmit; });

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e?.keyCode === 13) onSubmitRef.current?.();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [])

    return (
        <div className="h-screen overflow-y-auto flex flex-col lg:flex-row">

            {/* ── LEFT BRAND PANEL (shared with Login) ── */}
            <div
                className="relative hidden lg:flex lg:w-1/2 flex-col items-center justify-center overflow-hidden"
                style={{ background: 'linear-gradient(145deg, #060e1d 0%, #091828 55%, #0d2040 100%)' }}
            >
                {/* Decorative blurred orbs */}
                <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full opacity-20"
                    style={{ background: 'radial-gradient(circle, #3b82f6 0%, transparent 70%)' }} />
                <div className="absolute -bottom-32 -right-20 w-[28rem] h-[28rem] rounded-full opacity-10"
                    style={{ background: 'radial-gradient(circle, #3b82f6 0%, transparent 70%)' }} />

                {/* Grid pattern overlay */}
                <div className="absolute inset-0 opacity-[0.04]"
                    style={{
                        backgroundImage: 'linear-gradient(#3b82f6 1px, transparent 1px), linear-gradient(90deg, #3b82f6 1px, transparent 1px)',
                        backgroundSize: '40px 40px'
                    }} />

                {/* Brand content */}
                <div className="relative z-10 flex flex-col items-center text-center px-12">
                    <div className="mb-10 p-6 rounded-3xl bg-white/5 backdrop-blur-sm border border-white/10 shadow-2xl">
                        <BluestuffLogo variant="dark" className="h-8 w-auto" />
                    </div>

                    <h2 className="text-3xl font-bold text-white mb-4 leading-tight">
                        Sportsbook<br />Management Platform
                    </h2>
                    <p className="text-slate-400 text-base leading-relaxed max-w-xs">
                        All-in-one back-office suite for monitoring, operations, and analytics — in real time.
                    </p>

                    <div className="mt-10 flex flex-col gap-3 w-full max-w-xs">
                        {[
                            { Icon: Zap, label: 'Real-time Monitoring' },
                            { Icon: BarChart2, label: 'Advanced Reporting & BI' },
                            { Icon: ShieldCheck, label: 'Enterprise-grade Security' },
                        ].map(({ Icon, label }) => (
                            <div
                                key={label}
                                className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm"
                            >
                                <Icon className="h-4 w-4 text-blue-400 shrink-0" />
                                <span className="text-sm font-medium text-slate-200">{label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <p className="absolute bottom-6 text-slate-600 text-xs">
                    © {new Date().getFullYear()} Bluestuff. All rights reserved.
                </p>
            </div>

            {/* ── RIGHT FORM PANEL ── */}
            <div className="flex-1 flex flex-col items-center justify-center bg-gray-50 dark:bg-slate-900 p-6 sm:p-10">

                {/* Mobile-only logo */}
                <div className="flex lg:hidden mb-8">
                    <BluestuffLogo className="h-9 w-auto" />
                </div>

                <div className="w-full max-w-sm">

                    {/* Heading */}
                    <div className="mb-8">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                            Change Password
                        </h1>
                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                            Set a new password for your account
                        </p>
                    </div>

                    <div className="space-y-5">

                        {/* Old Password */}
                        <div className="space-y-1.5">
                            <Label htmlFor="previousPassword" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                Old Password
                            </Label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                                <Input
                                    id="previousPassword"
                                    type={showPrev ? 'text' : 'password'}
                                    name="previousPassword"
                                    value={formData.previousPassword}
                                    placeholder="Enter old password"
                                    onChange={onChangeHandler}
                                    className={`pl-9 pr-10 h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors ${errors.previousPassword ? 'border-destructive focus-visible:ring-destructive' : ''}`}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPrev(v => !v)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                                >
                                    {showPrev ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                                </button>
                            </div>
                            {errors.previousPassword && (
                                <p className="text-xs text-destructive flex items-center gap-1 mt-1">
                                    <AlertCircle className="h-3 w-3" />
                                    {errors.previousPassword}
                                </p>
                            )}
                        </div>

                        {/* New Password */}
                        <div className="space-y-1.5">
                            <Label htmlFor="newPassword" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                New Password
                            </Label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                                <Input
                                    id="newPassword"
                                    type={showNew ? 'text' : 'password'}
                                    name="newPassword"
                                    value={formData.newPassword}
                                    placeholder="Enter new password"
                                    maxLength={16}
                                    onChange={onChangeHandler}
                                    className={`pl-9 pr-10 h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors ${errors.newPassword && !isAllClear ? 'border-destructive focus-visible:ring-destructive' : ''}`}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowNew(v => !v)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                                >
                                    {showNew ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                                </button>
                            </div>

                            {/* Password strength checklist */}
                            {isAllClear !== '' && (
                                <div className="mt-2 p-3 rounded-lg bg-gray-50 dark:bg-slate-800 border border-gray-100 dark:border-slate-700 space-y-1.5">
                                    {ErrorStackData.map((item) => {
                                        const state = errorStack[item.key];
                                        return (
                                            <div key={item.id} className="flex items-center gap-2">
                                                {state === true ? (
                                                    <CircleCheck className="h-3.5 w-3.5 shrink-0 text-green-500" />
                                                ) : state === false ? (
                                                    <XCircle className="h-3.5 w-3.5 shrink-0 text-destructive" />
                                                ) : (
                                                    <div className="h-3.5 w-3.5 shrink-0 rounded-full border border-gray-300 dark:border-slate-600" />
                                                )}
                                                <span className={`text-xs ${state === true ? 'text-green-600 dark:text-green-400' : state === false ? 'text-destructive' : 'text-gray-500 dark:text-gray-400'}`}>
                                                    {item.label}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* Confirm Password */}
                        <div className="space-y-1.5">
                            <Label htmlFor="confirmNewPassword" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                Confirm New Password
                            </Label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                                <Input
                                    id="confirmNewPassword"
                                    type={showConfirm ? 'text' : 'password'}
                                    name="confirmNewPassword"
                                    value={formData.confirmNewPassword}
                                    placeholder="Confirm your new password"
                                    onChange={onChangeHandler}
                                    className={`pl-9 pr-10 h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors ${errors.confirmNewPassword ? 'border-destructive focus-visible:ring-destructive' : ''}`}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirm(v => !v)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                                >
                                    {showConfirm ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                                </button>
                            </div>
                            {errors.confirmNewPassword && (
                                <p className="text-xs text-destructive flex items-center gap-1 mt-1">
                                    <AlertCircle className="h-3 w-3" />
                                    {errors.confirmNewPassword}
                                </p>
                            )}
                        </div>

                        {/* Success banner */}
                        {forceResetPasswordData?.status === true && (
                            <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800 text-green-700 dark:text-green-300 text-sm">
                                <CircleCheck className="h-4 w-4 shrink-0" />
                                Password changed successfully. Redirecting to login…
                            </div>
                        )}

                        {/* Submit */}
                        <Button
                            onClick={onSubmit}
                            disabled={loading}
                            className="w-full h-11 text-sm font-semibold shadow-md hover:shadow-lg transition-all duration-200 mt-2"
                            style={{ background: 'linear-gradient(135deg, #1a86f3 0%, #0d5bbd 100%)' }}
                            size="lg"
                        >
                            {loading ? (
                                <>
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                    Updating…
                                </>
                            ) : (
                                'Reset Password'
                            )}
                        </Button>

                        {/* Back to login */}
                        <p className="text-center text-sm text-gray-500 dark:text-gray-400">
                            Remember your password?{' '}
                            <button
                                type="button"
                                onClick={() => history.push('login')}
                                className="font-medium text-[#1a86f3] hover:underline"
                            >
                                Back to Login
                            </button>
                        </p>
                    </div>

                    <p className="text-center text-xs text-gray-400 dark:text-gray-500 mt-8 flex items-center justify-center gap-1.5">
                        <Lock className="h-3 w-3" />
                        Protected by enterprise-grade security
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AddNewPassword;